import { Component, ContentChildren, QueryList, AfterContentInit } from "@angular/core";
import { Tab } from "./tab";

@Component({
    selector: "tabs",
    template:`
    <ul class="nav nav-pills">
      <li class="nav-item" *ngFor="let tab of tabs" (click)="selectTab(tab)">
        <span class="nav-link clickable" [class.active]="tab.active">{{tab.title}}</span>
      </li>
    </ul>
    <ng-content></ng-content>
  `, styles: [`
    .clickable {
        cursor: pointer;
    }
    .nav-link:not(.active){
        color: #0275d8;
        background-color: #ffffff;
    }
  `],
})
export class Tabs implements AfterContentInit {

    @ContentChildren(Tab) tabs: QueryList<Tab>;

    ngAfterContentInit(): void {

        let activeTabs = this.tabs.filter((tab) => tab.active);

        if (activeTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }
    }

    selectTab(tab: Tab): void {
        this.tabs.toArray().forEach(tab => {
            tab.active = false;
            tab.deactivate();
        });
        tab.active = true;
        tab.activate();
    }

}
